import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataType, IShowcase } from './interfaces/interfaces';
import Types from '../../../types/types';
const { initUnsavedChanges } = Types;
export const initialXPathLabel = 'Введите новое название';
export const initAttributeType = 'Nullable(String)';
export const initDescriptionCode = 'to_str';
export const initDescriptionNumber = 7;

interface ICdaRedactorTabs {
  label: string;
  fileName: string;
  code: string;
  key: string;
  closable: boolean;
}

export interface IMaxDataItemChildren {
  englishName: string;
  attributeType: string;
  xmlPath: string;
  parentCode: string;
  mandatory_plurality: string;
  oidDirectory: string;
  section: string;
  description: string;
  isParent: boolean;
  result: string;
}
export interface IMaxDataItem {
  title: { key: string; label: string; children: IMaxDataItemChildren };
  key: string;
  children: Array<IMaxDataItem>;
}
interface hasUnsavedChanges {
  general: boolean;
  CDA: boolean;
  target_showcase: boolean;
}
export interface AppState {
  editableTable: DataType;
  cdaRedactorTabs: Array<ICdaRedactorTabs>;
  activeXmlTab: string;
  maxData: Array<IMaxDataItem>;
  checkedKeysXPathes: string[];
  parentCodeOptions: Array<{ value: string; label: string }>;
  expandedKeys: string[];
  targetShowcaseData: Array<IShowcase>;
  targetShowcaseEditingField: boolean;
  searchXPathVal: string;
  visDeletedRow: Array<string | number>;
  activeBlocksKeys: Array<string>;
  isFullScreen: boolean;
  xPathErrors: Array<string>;
  currentTab: string;
  hasUnsavedChanges: hasUnsavedChanges;
}
export const initialEditableTable = {
  key: '',
  id: null,
  project_name: '',
  description: '',
  doc_type: [],
  date_creation: '',
  created_at: '',
  updated_at: '',
  author_changes: '',
  date_change: '',
  author: '',
  status: null,
  statuses: { id: null, status: '', description: '' },
  is_ready_to_test: false,
  claim_is_created: false,
  mart_code: '',
};

export const initialCdaRedactorTabs = [
  {
    label: 'Введите название вкладки',
    fileName: '',
    code: '',
    key: '1',
    closable: true,
  },
];

export const initialChildren = {
  englishName: '',
  attributeType: initAttributeType,
  xmlPath: '',
  parentCode: '',
  mandatory_plurality: '0..1',
  oidDirectory: '',
  section: '',
  description: '',
  isParent: false,
  result: '',
};
export const initialTitle = {
  key: '0-0',
  label: initialXPathLabel,
  children: { ...initialChildren },
};
export const initialMaxData = [
  {
    title: { ...initialTitle },
    key: '0-0',
    children: [],
  },
];

export const initialState: AppState = {
  editableTable: initialEditableTable,
  cdaRedactorTabs: initialCdaRedactorTabs,
  activeXmlTab: '1',
  maxData: [],
  checkedKeysXPathes: [],
  parentCodeOptions: [{ label: ' ', value: 'null' }],
  expandedKeys: [],
  targetShowcaseData: [],
  targetShowcaseEditingField: false,
  searchXPathVal: '',
  visDeletedRow: [],
  activeBlocksKeys: [],
  isFullScreen: false,
  xPathErrors: [],
  currentTab: 'general',
  hasUnsavedChanges: { ...initUnsavedChanges },
};

export const tablesSlice = createSlice({
  name: 'tablesSlice',
  initialState,
  reducers: {
    setEditableTable(state, action: PayloadAction<DataType>) {
      state.editableTable = action.payload;
    },
    setCdaRedactorTabs(state, action: PayloadAction<Array<ICdaRedactorTabs>>) {
      state.cdaRedactorTabs = action.payload;
    },
    setMaxData(state, action: PayloadAction<Array<IMaxDataItem>>) {
      state.maxData = action.payload;
    },
    setCheckedKeysXPathes(state, action: PayloadAction<Array<string>>) {
      state.checkedKeysXPathes = action.payload;
    },
    setActiveXmlTab(state, action: PayloadAction<string>) {
      state.activeXmlTab = action.payload;
    },
    setParentCodeOptions(state, action: PayloadAction<Array<{ label: string; value: string }>>) {
      state.parentCodeOptions = action.payload;
    },
    setExpandedKeys(state, action: PayloadAction<Array<string>>) {
      state.expandedKeys = action.payload;
    },
    setTargetShowcaseData(state, action: PayloadAction<Array<IShowcase>>) {
      state.targetShowcaseData = action.payload;
    },
    setSearchXPathVal(state, action: PayloadAction<string>) {
      state.searchXPathVal = action.payload;
    },
    setVisDeletedRow(state, action: PayloadAction<Array<string | number>>) {
      state.visDeletedRow = action.payload;
    },
    setActiveBlockKeys(state, action: PayloadAction<Array<string>>) {
      state.activeBlocksKeys = action.payload;
    },
    onFullScreen(state, action: PayloadAction<boolean>) {
      state.isFullScreen = action.payload;
    },
    setDocumentTab(state, action: PayloadAction<string>) {
      state.currentTab = action.payload;
    },
    setTargetShowcaseEditingField(state, action: PayloadAction<boolean>) {
      state.targetShowcaseEditingField = action.payload;
    },
    setHasUnsavedChanges(state, action: PayloadAction<hasUnsavedChanges>) {
      state.hasUnsavedChanges = action.payload;
    },
    setError(state, action: PayloadAction<Array<string>>) {
      state.xPathErrors = action.payload;
    },
  },
});

export default tablesSlice.reducer;
